import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const demandsState = (state: AppState) => state.demandDetail;

export const demandDetailParticipantsDataSelector = createSelector(demandsState, state => state.participants.stepData);

/** What the step compares against to decide whether anything is unsaved. */
export const demandDetailParticipantsBaselineSelector = createSelector(
    demandsState,
    state => state.participants.baseline
);
